export const fedopsInteractions = {
	submitTicket: 'submit-ticket',
	searchArticle: 'search-article',
	viewArticle: 'view-article'
};
